// TODO - remove lint disable when editing this file
// TODO - remove lint disable when editing this file
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ACTION_WEBSKED_DISABLED } from '~/redux/settingsReducer'
import { getWebskedTasks } from '../websked'

const webskedDisabledListenerEpic = (action$, store, { serviceResolver }) =>
  action$
    .ofType(ACTION_WEBSKED_DISABLED)
    .filter((action) => !action.payload)
    .map(() => getWebskedTasks())

export default webskedDisabledListenerEpic
